import { DetailedHTMLProps, FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export type BreadcrumbsProps = {
    variant: 'page' | 'step';
    children: Array<ReactNode>;
    currentIndex?: number;
} & DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;

export const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({
    className,
    variant,
    currentIndex,
    children,
    ...props
}) => {
    return (
        <nav {...props} className={classNames(styles.container, className)}>
            <ol itemScope itemType="https://schema.org/BreadcrumbList">
                {children.map((child, index) => {
                    return (
                        <li
                            key={index}
                            aria-current={index === currentIndex ? variant : undefined}
                            itemProp="itemListElement"
                            itemScope
                            itemType="https://schema.org/ListItem"
                        >
                            {child}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
